/** Textos legais / crédito no rodapé da landing pública. */

export const FOOTER_LEGAL_PRODUCT_NAME = 'RetornaAr';

export const FOOTER_LEGAL_RIGHTS_RESERVED = 'Todos os direitos reservados.';

/** Crédito de desenvolvimento (exibido no rodapé). */
export const FOOTER_LEGAL_DEVELOPER_CREDIT = 'Desenvolvido por MarizLabs.';

export const FOOTER_LEGAL_VERSION_PREFIX = 'Versão';

export const FOOTER_LEGAL_LINK_PRIVACY = 'Privacidade';

export const FOOTER_LEGAL_LINK_TERMS = 'Termos de Uso';
